import { UIElement } from "./ui_element.js";

export class UIGradientOverlay extends UIElement
{
  private color_top: string;
  private color_bottom: string;

  constructor(
    ctx: CanvasRenderingContext2D,
    x: number,
    y: number,
    width: number,
    height: number,
    color_top: string,
    color_bottom: string,
    options?: any
  )
  {
    super( ctx, x, y, width, height, false, false, options );
    this.color_top = color_top;
    this.color_bottom = color_bottom;
  }

  name(): string { return "UIGradientOverlay"; }

  protected override syncDomContent( node: HTMLElement ): boolean
  {
    const background = `linear-gradient(${this.color_top}, ${this.color_bottom})`;
    if ( node.style.background !== background )
      node.style.background = background;
    return true;
  }

  render(): void
  {
    if ( !this.shouldBeRendered() )
      return;

    this.startRender();

    const w = this.rect.getW();
    const h = this.rect.getH();

    const gradient = this.ctx.createLinearGradient(
      0, -this.rect.getH2(),
      0, this.rect.getH2()
    );

    gradient.addColorStop( 0, this.color_top );
    gradient.addColorStop( 1, this.color_bottom );

    this.ctx.fillStyle = gradient;
    this.ctx.fillRect(
      -this.rect.getW2(),
      -this.rect.getH2(),
      w,
      h
    );

    this.finishRender();
  }
}
